// program to generate random strings
// declare all characters
const characters = 'abcdefghijklmnopqrstuvwxyz0123456789'
export function generateString(length) {
  let result = ''
  const charactersLength = characters.length
  for (let i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength))
  }

  return result
}



// WEBPACK FOOTER //
// ./src/utils/generateString.js